import React from "react";
import BreadCrumb from "../../components/Breadcrumb";
import PractitionerItem from "../../components/PractitionerItem";
import RamtinImage from "../../assets/images/ram-thumb.png";
import KimImage from "../../assets/images/kim-thumb.png";
const PractitionerPromo = () => {
  return (
    <div className="promo-page">
      <BreadCrumb pageName="Practitioners" />
      <h3 className="page-title">Practitioners</h3>
      <p className="page-desc">
        Choose the practitioner that best matches your needs
      </p>
      <p className="mt-2">
        <span>Practitioners</span> - Free yourself from the guesswork, our
        licensed herbalists will create a custom herbal formula for you.
      </p>
      <p>
        <span>Patients</span> - Our licensed herbalists will create a custom
        herbal formula for your specific needs.
      </p>
      <div className="mt-3">
        <PractitionerItem
          name="Ramtin Dehkhoda, LAc MSTOM"
          image={RamtinImage}
          description="Ramtin is an accomplished primary care practitioner renowned for his
          expertise in traditional Chinese medicine through his establishment of
          San Diego Herbal Medicine and Acupuncture. His comprehensive approach
          spans various medical realms, from specializing in internal medicine
          such as digestive health, autoimmune disorders, psycho emotional
          wellness, fertility, post viral conditions, sleep and memory to
          orthopedic conditions and sports performance."
          profileLink="/ramtin"
          consulatationLink="https://sdhma.janeapp.com/locations/my-herbal-pharmacy/book#/staff_member/11/treatment/544"
          id="2127"
        />
        <PractitionerItem
          name="Dr. Kim DiStefano, LAc DACM"
          image={KimImage}
          description="Dr. Kim's passion for medicine ignited during her upbringing around
          healthcare, leading to a deep-rooted interest in holistic healing
          methods. Her journey, from Dickinson College to a Doctorate in Chinese
          Medicine at Pacific College of Oriental Medicine in New York City and
          San Diego, showcases her dedication to blending Eastern modalities
          with herbal remedies for gynecological disorders, post-operative care,
          and respiratory ailments. Her expertise spans across various
          specialties, including treating depression, orthopedic disorders, and
          chronic pain syndromes. Notably, she's known for crafting herbal
          coffee alternatives that optimize focus and productivity, reflecting
          her innovative approach to healthcare and well-being."
          profileLink="/kim"
          consulatationLink="https://sdhma.janeapp.com/locations/my-herbal-pharmacy/book#/staff_member/24/treatment/544"
          id="1600"
        />
      </div>
    </div>
  );
};

export default PractitionerPromo;
